// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9fd1d7af","879":"dff3a192"}[chunkId] + ".chunk.js";
};